export const getters = {
  getModalViewTicket: state => state.modalViewTicket,
  getTickets: state => state.tickets,
  getTicket: state => state.ticket
};

export default {};
